import { Fragment } from 'react';
import { Title } from 'react-admin';

const Dashboard = () => ( 
    <Fragment>
        <div>Dash</div>
        <Title title='Hydrant Fleet Management' />
        <br/>
        <br/>
        <br/>
    </Fragment>
);

export default Dashboard;
